export default "/static/images/build_middle_6.png?574a071cde038e9be8010e2baf90f114";